module.exports = __webpack_public_path__ + "img/se.4a944ffe.svg";